import React from 'react';
import {ContainerNuevo, ContainerOptions, Explanation, InputError, InputOption, InputSend, LabelCart, LabelName} from './cuenta.elements';
import {ContenedorGlobal} from '../../components/Theme/theme.elements';
import {Form, Formik} from 'formik';
import * as Yup from 'yup';
import {Link} from 'react-router-dom';
import {useTenantContext} from '../../tenant/TenantContext';
import {RemoteDataUI} from '../../common/ui/RemoteDataUI';
import {Spinner} from 'react-bootstrap';
import {useCredentialsRequest} from '../application/useCredentialsRequest';

/**
 * "Solicitar credenciales nuevas": para clientes ya autorizados que no pueden entrar (contraseña
 * temporal caducada, correo de bienvenida perdido...). No da acceso a nadie: avisa a la empresa,
 * que reenvía las credenciales desde el admin.
 */
export const CredentialsRequest = () => {
  const { tenantId, name, tel } = useTenantContext();
  const { requestRemoteData, request } = useCredentialsRequest();

  const validationSchema = Yup.object({
    numCliente: Yup.string()
                   .required('Este campo es obligatorio')
                   .min(2, 'El valor del campo es demasiado corto'),
    nombre: Yup.string()
               .required('Este campo es obligatorio')
               .min(2, 'El valor del campo es demasiado corto'),
    email: Yup.string()
              .email('El email no tiene un formato correcto')
              .required('Este campo es obligatorio'),
    telefono: Yup.string()
                 .matches(/^(\+\d{1,3})?\s?-?\d{3}\s?-?\d{3}\s?-?\d{3}$/, 'Introduzca un teléfono válido (ej: 123 456 789 o +34 123 456 789)')
  });

  return (
    <div className="pt-4">
      <ContenedorGlobal className="narrow">
        <ContainerNuevo className="col-md-12 bs coloured" background={'#F0F0F0'}>
          <div className="col-md-12">
            <LabelName>Solicitar credenciales nuevas</LabelName>
          </div>
          <RemoteDataUI remoteData={requestRemoteData}>
            <RemoteDataUI.Initial>
              <p className="mb-3">
                Si ya tienes acceso al portal pero tu contraseña temporal ha caducado o no encuentras el correo de
                bienvenida, indícanos tus datos y te enviaremos unas credenciales nuevas al email que tenemos registrado.
              </p>
              <Formik
                initialValues={{ numCliente: '', nombre: '', email: '', telefono: '' }}
                validationSchema={validationSchema}
                onSubmit={(values) => request(values, tenantId)}>
                {({ handleChange, handleBlur, values, errors, touched }) => (
                  <Form>
                    <div className="row">
                      <ContainerOptions className="col-md-4">
                        <LabelCart className="mandatory">Código de cliente</LabelCart>
                        <InputOption type="text" id="numCliente" value={values.numCliente} onChange={handleChange} onBlur={handleBlur} />
                        <Explanation>El mismo con el que inicias sesión</Explanation>
                        {errors.numCliente && touched.numCliente && (<InputError>{errors.numCliente}</InputError>)}
                      </ContainerOptions>

                      <ContainerOptions className="col-md-8">
                        <LabelCart className="mandatory">Nombre y apellidos</LabelCart>
                        <InputOption type="text" id="nombre" value={values.nombre} onChange={handleChange} onBlur={handleBlur} />
                        {errors.nombre && touched.nombre && (<InputError>{errors.nombre}</InputError>)}
                      </ContainerOptions>

                      <ContainerOptions className="col-md-7">
                        <LabelCart className="mandatory">Correo electrónico</LabelCart>
                        <InputOption type="text" id="email" value={values.email} onChange={handleChange} onBlur={handleBlur} />
                        {errors.email && touched.email && (<InputError>{errors.email}</InputError>)}
                      </ContainerOptions>

                      <ContainerOptions className="col-md-5">
                        <LabelCart>Teléfono</LabelCart>
                        <InputOption type="text" id="telefono" value={values.telefono} onChange={handleChange} onBlur={handleBlur} />
                        {errors.telefono && touched.telefono && (<InputError>{errors.telefono}</InputError>)}
                      </ContainerOptions>
                    </div>
                    <div className="mt-4 explanation">
                      <p>Revisaremos la solicitud y te enviaremos las credenciales lo antes posible. Si tienes prisa, llámanos al {tel}.</p>
                    </div>
                    <div className="d-flex flex-column flex-md-row justify-content-center justify-content-md-between align-items-md-end gap-2 submit-row">
                      <InputSend type="submit" value="Enviar solicitud" />
                      <div className="order-md-first text-center">
                        <Link to="/iniciar-sesion">Volver a inicio de sesión</Link>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </RemoteDataUI.Initial>

            <RemoteDataUI.Pending>
              <div className="d-flex justify-content-center">
                <Spinner />
              </div>
            </RemoteDataUI.Pending>

            <RemoteDataUI.Success>
              {() => (
                <div className="successMessage text-success">
                  <p>Hemos recibido tu solicitud. Te enviaremos las credenciales nuevas al email que tenemos registrado.</p>
                  <p>Gracias por confiar en {name}</p>
                </div>
              )}
            </RemoteDataUI.Success>

            <RemoteDataUI.Failure>
              <div className="errorMessage">
                <p>No se ha podido enviar la solicitud. Por favor, reintenta más tarde o llámanos al {tel}.</p>
              </div>
            </RemoteDataUI.Failure>
          </RemoteDataUI>
        </ContainerNuevo>
      </ContenedorGlobal>
    </div>
  );
};
